<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('exchange_rate') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="exchangerate" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item">{{ $t('exchange_rate') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-1">
                            <div class="form-group">
                                <select class="form-control" v-model="query.Year" @change="toList">
                                    <option 
                                        v-for="year in $years()" 
                                        :value="year" 
                                        :key="year">
                                        {{ year }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            <div class="form-group">
                                <select class="form-control" v-model="query.Month" @change="toList">
                                    <option 
                                        v-for="month in 12" 
                                        :value="month" 
                                        :key="month">
                                        {{ $t('month_' + month) }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered no-bor">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                <th>{{$t('date')}}</th>
                                <th>{{$t('currency_value')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index" :class="{'bg-info': isToday(ret.Date)}">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name:'exchange_rate_update', params: { id: ret.Id }}">{{$format(ret.Date, 'DD/MM/YYYY')}}</router-link></td>
                                <td>{{ret.Value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    export default {
        data: function(){
            return {
                query: {
                    Month: this.$now().format('M'),
                    Year: this.$now().format('YYYY')
                },
                records:[],
            }
        },
        created() {
            this.toList();
        },
        methods: {
            toList: function(){
                let loading = this.$loading.show();
                this.$api().post('exchangerates', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.ExchangeRates;
                    }
                }).finally(function(){ loading.hide(); });
            },
            isToday: function (date) {
                let ret = false;
                if(moment(date).format('YYYY-MM-DD') == this.$now().format('YYYY-MM-DD')) ret = true;
                return ret;
            }
        }
    }
</script>
<style scoped>
    .bg-info a {
        color: #fff !important;
    }
</style>